<template>
  <div>
    <div class="banner">
      <a-row type="flex" justify="space-around" align="middle" :gutter="[40, 40]">
        <a-col :span='14'>
          <h1>FutureAI信息科技学生素养评价系统为教育管理部门和学校提供智能评价服务方案</h1>
          <span style="margin-top:30px;" class="btn">查看系统演示</span>
        </a-col>
        <a-col :span='10'><img src="../assets/banner2.png" alt=""></a-col>
      </a-row>
    </div>
    <div class="section">
      <div class="title">
        <h2>产品意义</h2>
        <img src="../assets/divider.png" alt="">
      </div>
      <div class="content">
        <h3 class="subtitle">FutureAI信息科技核心素养评价系统适时推出，助力区域信息科技和人工智能教育发展，对中小学生信息科技学生素养发展水平做出专业评价，优化教学成果和方法。</h3>
        <div class="wrap1">
          <a-row type="flex" justify="space-around" align="middle" :gutter="[24,24]">
            <a-col :span="12">
              <div class="card1">
                <img src="../assets/mean1.png" alt="">
              </div>
            </a-col>
            <a-col :span="12">
              <div class="card1 shadow">
                <h3>区域测评</h3>
                <p>评价系统助力教育主管部门通过智能化手段，了解和分析区域信息科技或人工智能教育发展水平，结合专家顾问，便于主管单位决策者推动信息科技教育创新。</p>
              </div>
            </a-col>

            <a-col :span="12">
              <div class="card1 shadow">
                <h3>选拔测</h3>
                <p>依托FutureAI丰富实测数据，精准定位学生在科技特长方面学习能力层次，为教师差异化教学提供精准指引。</p>
              </div>
            </a-col>
            <a-col :span="12">
              <div class="card1">
                <img src="../assets/mean2.png" alt="">
              </div>
            </a-col>
            
            <a-col :span="12">
              <div class="card1">
                <img src="../assets/mean3.png" alt="">
              </div>
            </a-col>
            <a-col :span="12">
              <div class="card1 shadow">
                <h3>随堂测</h3>
                <p>帮助教师验证教学目标，改进教学策略，提升教学效果。</p>
              </div>
            </a-col>

            <a-col :span="12">
              <div class="card1 shadow">
                <h3>单元测</h3>
                <p>同步配套理论综合练习，及时了解学生章节掌握情况，巩固知识点。</p>
              </div>
            </a-col>
            <a-col :span="12">
              <div class="card1">
                <img src="../assets/mean4.png" alt="">
              </div>
            </a-col>

            <a-col :span="12">
              <div class="card1">
                <img src="../assets/mean5.png" alt="">
              </div>
            </a-col>
            <a-col :span="12">
              <div class="card1 shadow">
                <h3>期中测</h3>
                <p>阶段性教学评价，及时发现薄弱环节，优化学习路径。</p>
              </div>
            </a-col>

            <a-col :span="12">
              <div class="card1 shadow">
                <h3>期末测</h3>
                <p>学生成绩可视化，快速验收学习成效，巩固学习成果。</p>
              </div>
            </a-col>
            <a-col :span="12">
              <div class="card1">
                <img src="../assets/mean6.png" alt="">
              </div>
            </a-col>
          </a-row>
        </div>
      </div>
    </div>
    <div class="section section-gray">
      <div class="title">
        <h2>产品特色</h2>
        <img src="../assets/divider.png" alt="">
      </div>
      <div class="content">
        <h3 class="subtitle"></h3>
        <div class="wrap2">
            <a-row>
                <a-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                    <img src="../assets/report1.png" alt="">
                </a-col>
                <a-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                    <img src="../assets/report2.png" alt="">
                </a-col>
                <a-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                    <img src="../assets/report3.png" alt="">
                </a-col>
            </a-row>
        </div>
      </div>
    </div>
    <div class="section">
      <div class="title">
        <h2>产品优势</h2>
        <img src="../assets/divider.png" alt="">
      </div>
      <div class="content">
        <h3 class="subtitle">该系统具备人工智能核心素养模型和信息科技学生素养模型将准确测出学生的知识储备、特长发展、学习行为、学习漏洞等多方面的情况做出综合评价，为信息科技课堂教学和区域科技教育发展提供科学依据。</h3>
        <div class="wrap1">
            <a-row :gutter="[24,24]">
                <a-col :span="8">
                    <div class="card2">
                        <h3>成本省</h3>
                        <p>无需复杂的系统部署或大量人力物力投入，网页版服务，一键部署，减少后顾之忧。</p>
                    </div>
                </a-col>
                <a-col :span="8">
                    <div class="card2">
                        <h3>评价快</h3>
                        <p>创建班级，凭学号参加评价，自动批改判卷，实时生成报告。</p>
                    </div>
                </a-col>
                <a-col :span="8">
                    <div class="card2">
                        <h3>诊断准</h3>
                        <p>基于人工智能算法，结合FUTUREAI丰富实测数据，全方位精准诊断学生学情。</p>
                    </div>
                </a-col>
                 <a-col :span="8">
                    <div class="card2">
                        <h3>题量大</h3>
                        <p>50000+道信息科技素养试题，1万+套试卷，更有模拟练习资源，均可直接发起普测。</p>
                    </div>
                </a-col>
                 <a-col :span="8">
                    <div class="card2">
                        <h3>分工细</h3>
                        <p>覆盖各角色各场景，提升教学管理效率，使管理人员产能最大化。</p>
                    </div>
                </a-col>
                 <a-col :span="8">
                    <div class="card2">
                        <h3>操作易</h3>
                        <p>一键发布测评，操作简单便捷，彻底告别繁冗的测评流程。</p>
                    </div>
                </a-col>
            </a-row>
        </div>
      </div>
    </div>

    <div class="section">
      <div class="title">
        <h2>平台支持</h2>
        <img src="../assets/divider.png" alt="">
      </div>
      <div class="content">
        <h3 class="subtitle"></h3>
        <div class="wrap1">
            <img src="../assets/suport.png" style="width:100%;max-width:1000px;" alt="">
        </div>
      </div>
    </div>
    <div class="section">
      <div class="title">
        <h2>考务管理</h2>
        <img src="../assets/divider.png" alt="">
      </div>
      <div class="content">
        <h3 class="subtitle"></h3>
        <div class="wrap1">
            <img src="../assets/admin3.png" alt="">
            <img src="../assets/admin2.png" alt="">
            <img src="../assets/admin1.png" alt="">
            <img src="../assets/report.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
.btn{
  display: inline-block;
  background:linear-gradient(180deg, rgb(250,194,44), rgb(255,101,73));
  border-radius:5px;
  padding:10px 20px;
  color:white;
  font-size: 16px;
  cursor: pointer;
}
.banner{

}
.section-gray{
    // background: rgb(243,243,243);
}
.section{
  padding-top: 40px;
  .title{
    text-align: center;
    h2{
      font-size: 30px;
      font-weight: 600;
      margin-bottom: 20px;
    }
    img{
      width: 150px;
    }
  }
  .content{
    .subtitle{
      margin: 20px auto;
      display: block;
      max-width: 600px;
      text-align: center;
    }

    .wrap1{
      text-align: center;
      .card1{
        margin: 0 auto;
        padding: 20px 20px;
        text-align: center;
        border-radius: 5px;
        max-width: 350px;
        min-height: 170px;
      }
     .card2{
        margin: 0 auto;
        padding: 20px 20px;
        text-align: center;
        border-radius: 5px;
        max-width: 350px;
        min-height: 170px;
        background: #f3f3f3;
        box-shadow: #e3e3e3 5px 5px 5px 0px;
        p{
            text-indent:0em;
            text-align: center;
        }
      }
      .shadow{
        box-shadow: #e3e3e3 5px 5px 5px 0px;
      }

      h3{
        color: #fe7500;
        font-weight: 700;
        margin-bottom: 20xp;
      }
      p{
        text-indent:2em;
        text-align: left;
      }
    }
  }
}
</style>>

</style>